import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest } from 'redux-saga/effects'
import { AccountModel } from '../models/Account'
import { deleteAccount,getListGmailAccount,addProxies } from './AccountCRUD'
export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  RequestAccount: '[Accounts] Requested',
  AccountsLoadedSuccess: '[Accounts] Loaded succcess',
  AccountsLoadedFail: '[Accounts] load fail',
  DeleteAccount: '[Accounts] DeleteAccount',
  DeleteSuccess: '[Accounts] DeleteSuccess',
  RequestAddProxy: '[Accounts] RequestAddProxy',
  AddProxySuccess: '[Accounts] AddProxySuccess',
  UpdateCountFree: '[Accounts] UpdateCountFree',
  ChangeLoading: '[Accounts] ChangeLoading'
}

const initialAccountState: IAccountState = {
  accounts: [],
  loading: false,
  currentAccount:undefined,
  deleting:false,
  ip:'',
  success:[],
  countFree:0,
  currentAddPointAccount:undefined
}

export interface IAccountState {
  accounts: AccountModel[]
  loading: boolean
  currentAccount?:AccountModel
  ip:string,
  countFree:number,
  deleting:boolean,
  success:AccountModel[],
  currentAddPointAccount?:AccountModel
}

export const reducer = persistReducer(
  { storage, key: 'v1-accounts', whitelist: [] },
  (state: IAccountState = initialAccountState, action: ActionWithPayload<IAccountState>) => {
    switch (action.type) {
      case actionTypes.RequestAccount: {
        return {
          ...state,
          accounts: [],
          loading: true
        }
      }
      case actionTypes.AccountsLoadedSuccess: {
        return {
          ...state,
          accounts: action.payload?.accounts || [],
          loading: false
        }
      }
      case actionTypes.AccountsLoadedFail: {
        return {
          ...state,
          accounts: [],
          loading: false
        }
      }

      case actionTypes.DeleteAccount: {
        // @ts-ignore
        return {
          ...state,
          deleting:true,
        }
      }
      case actionTypes.ChangeLoading: {
        // @ts-ignore
        return {
          ...state,
          loading:action.payload?.loading||false,
        }
      }
      

      case actionTypes.DeleteSuccess: {
        // @ts-ignore
        console.log(action.payload?.username)
        return {
          ...state,
          accounts:state.accounts.filter(item=>{
            //console.log(item)
            // @ts-ignore
            if(item.username===action.payload?.username){
              return false
            }
            return true
          }),
          deleting: false
        }
      }
      case actionTypes.UpdateCountFree: {
        return {
          ...state,
          countFree:action.payload?.countFree||0
        }
      }
      case actionTypes.AddProxySuccess: {
        console.log(action.payload?.success)
        return {
          ...state,
          accounts:state.accounts.concat(action.payload?.success||[]),
          loading: false
        }       
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  requestAccounts: (user_id: number) => ({ type: actionTypes.RequestAccount, payload: { user_id } }),
  fulfillAccounts: (accounts: AccountModel[]) => ({ type: actionTypes.AccountsLoadedSuccess, payload: { accounts } }),
  loadAccountsFail: (message: string) => ({ type: actionTypes.AccountsLoadedFail, payload: { message } }),
  requestDelete: (username: string) => ({ type: actionTypes.DeleteAccount, payload: { username } }),
  changeLoading: (loading: boolean) => ({ type: actionTypes.ChangeLoading, payload: { loading } }),
  deleteSuccess: (username: string) => ({ type: actionTypes.DeleteSuccess, payload: { username } }),
  requestAddAccount: (data:{ips: string,username:string,passwd:string,number:number}) => ({ type: actionTypes.RequestAddProxy, payload: { data } }),
  addAccountSuccess: (success:AccountModel[]) => ({ type: actionTypes.AddProxySuccess, payload: { success } }),
  setCountFree: (countFree:number) => ({ type: actionTypes.UpdateCountFree, payload: { countFree } }),
}

export function* saga() {
  yield takeLatest(actionTypes.RequestAccount, function* userRequested(param: any) {
    try {
      const {data: res} = yield getListGmailAccount('', {})
      if(res.gmails){
        const proxyMap =res.gmails.map((item:any,index:number)=>{
          return {
            stt:index,
            ...item
          }
        }) 
        yield put(actions.setCountFree(res.totalFree))
        yield put(actions.fulfillAccounts(proxyMap))
      }else{
        yield put(actions.loadAccountsFail("Load Account lỗi"))
      }
    } catch (error) {
      console.log(" Fetch accounts error ",error)
    }
  })
  
  yield takeLatest(actionTypes.DeleteAccount, function* addPointUserRequested(param: any) {
    const {data: res} = yield deleteAccount(param.payload.username)
    if(res?.status==="success"){
      yield put(actions.deleteSuccess(param.payload.username))
    }else{

    }
  })

  yield takeLatest(actionTypes.RequestAddProxy, function* addPointUserRequested(param: any) {
    const {data: res} = yield addProxies(param.payload.data.ips)
    if(res?.proxies){
      console.log("=============here==============")
      yield put(actions.addAccountSuccess(res?.proxies))
    }
  })

}
